import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LandingPage } from "@/components/LandingPage";
import { PortraitCreator } from "@/components/PortraitCreator";
import { AdminPanel } from "@/components/AdminPanel";

function App() {
  // Check if we have payment params in URL - if so, show creator immediately
  const hasPaymentParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('payment') === 'success' && urlParams.get('order_id');
  };
  
  const [showCreator, setShowCreator] = useState(hasPaymentParams());

  return (
    <div className="App min-h-screen bg-[#f8f5f2] noise-bg relative">
      <BrowserRouter>
        <Routes>
          <Route 
            path="/" 
            element={
              showCreator ? (
                <PortraitCreator onBack={() => setShowCreator(false)} />
              ) : (
                <LandingPage onGetStarted={() => setShowCreator(true)} />
              )
            } 
          />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
